import React from "react";
import { Link } from "react-router-dom";

export default function FooterOutils() {
  const whatsappLink =
    "https://wa.me/22892076072?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20vos%20outils%20agricoles";

  return (
    <footer className="footer-bridge mt-5 pt-5">
      <div className="container pb-4">
        <div className="row g-4">
          {/* Col 1 : Présentation */}
          <div className="col-md-4">
            <h5 className="footer-title mb-3">
              🌾 Plateforme Outils Agricoles
            </h5>
            <p className="footer-text">
              Sélection d’équipements agricoles adaptés aux réalités du terrain :
              motoculteurs, pulvérisateurs, semoirs, tracteurs et plus encore.
            </p>
            <p className="footer-text small mb-0">
              Conseil, importation, installation et accompagnement pour vos
              projets agricoles.
            </p>
          </div>

          {/* Col 2 : Liens rapides */}
          <div className="col-6 col-md-3">
            <h6 className="footer-subtitle mb-3">Liens rapides</h6>
            <ul className="list-unstyled footer-links">
              <li>
                <Link to="/catalogue-outils" className="footer-link">
                  Catalogue des outils
                </Link>
              </li>
              {/* <li>
                <Link to="/reservation" className="footer-link">
                  Demande de devis
                </Link>
              </li> */}
              <li>
                <Link to="/navette" className="footer-link">
                  Services et accompagnement
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  Contact & assistance
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3 : Contact */}
          <div className="col-6 col-md-3">
            <h6 className="footer-subtitle mb-3">Nous contacter</h6>
            <ul className="list-unstyled footer-text small">
              <li className="mb-1">
                📍 Lomé, Togo
              </li>
              <li className="mb-1">
                📞 <a href="tel:+22892076072" className="footer-link">
                  +228 92 07 60 72
                </a>
              </li>
              <li className="mb-1">
                ✉️{" "}
                <a
                  href="mailto:contact@thebridgeofworld.com"
                  className="footer-link"
                >
                  contact@thebridgeofworld.com
                </a>
              </li>
            </ul>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="btn btn-bridge btn-sm mt-2"
            >
              📲 WhatsApp direct
            </a>
          </div>

          {/* Col 4 : Info / horaires */}
          <div className="col-md-2">
            <h6 className="footer-subtitle mb-3">Infos utiles</h6>
            <ul className="list-unstyled footer-text small">
              <li className="mb-1">🕒 Lun – Sam : 8h – 18h</li>
              <li className="mb-1">💳 Paiement mobile money</li>
              <li className="mb-1">🚚 Livraison possible en région</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bas de page */}
      <div className="footer-bottom border-top">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center py-3 gap-2">
          <p className="mb-0 small text-muted">
            © {new Date().getFullYear()} Plateforme Outils Agricoles – The Bridge.
            Tous droits réservés.
          </p>
          <div className="small text-muted">
            <Link to="/mentions-legales" className="footer-link me-3">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="footer-link">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
